<section class="section-autor" id="autor">

  <!-- ── Cabeçalho centralizado ── -->
  <div class="autor-header">

    <div class="autor-label anim">
      <!-- <h4>breakers</h4> -->
      <span class="autor-eyebrow">Por trás da história</span>
    </div>

    <h2 class="autor-title anim anim--delay-1">Conheça o Autor</h2>

    <div class="autor-divider anim anim--delay-2"></div>

    <p class="autor-subtitle anim anim--delay-3">
      É indescritivel a sensação de ver minha obra ganhar forma, entre páginas, rabiscos e experiências.
    </p>

  </div>

  <div class="autor-body">

    <!-- ── Coluna da foto ── -->
    <div class="autor-photo-col anim anim--delay-1">

      <div class="autor-photo-frame">
        <img
          src="assets/images/foto-autor.png"
          alt="Aaron Blaze — Autor de Breakers: A Queda das Chamas"
          class="autor-photo"
          loading="lazy"
        />
        <div class="autor-photo-overlay"></div>
      </div>

      <div class="autor-name-tag">
        <span class="autor-name">Aaron Blaze</span>
        <span class="autor-role">Escritor · Criador</span>
      </div>

    </div>

    <!-- ── Coluna de conteúdo ── -->
    <div class="autor-content anim anim--delay-2">

      <blockquote class="autor-quote">
        "Se tem uma coisa que eu posso dizer sobre meu livro, é que, como muitos dizem: 
          &mdash; ele é uma extensão de mim!"
      </blockquote>

      <div class="autor-bio">
        <p>
          Eu nunca fui uma pessoa de leitura. Por mais que minha mãe me incentivasse a tal ato, eu sempre
          achei bem chato. Na escola pra não dizer que nunca li, dois livros eu fui obrigado a ler, entre eles
          "A Viagem ao centro da Terra", e não foi das piores coisas que fiz não... mas eu sempre gostei mais de <b>DESENHAR.</b>
        </p>
        <p>E é ai que minha história como escritor se deu inicio.</p>
        <p>
          Inicialmente, Breakers era para ser um mangá. Aos meus 15 anos, eu iniciei um curso de desenho e nele surgiu a vontade 
          de criar uma história própria. Porém, não é todo mundo que consegue esse feito, não me falaram que mangás de boneco de palito
          não era comerciavel, e a ideia sumiu da minha mente... 
          Pelo menos era o que eu pensava...
        </p>
        <p>
          Quando já estava adulto, por motivos pessoais, e com certo interesse, pedi a minha mãe um livro de Maze Runner, e para minha surpresa...
          recebi um BOX. 4 livros devorados com menos de dois meses, e dai em diante a leitura passou a ter um outro 'gosto'... Até que (música dramática do Naruto)
          tudo começou a desabar na minha vida. 
        </p>
        <p>
           Diversos problemas juntos me deixaram BEM pra baixo. Até que um certo dia, no fundo da minha bolsa de trabalho eu encontrei um caderno, que
           a empresa deu nos seus 30 anos de existência. Fire Island, como era chamado antes, voltou a minha mente, e até hoje eu não sei o por que, eu 
           passei a escrever a historia que se tornaria Breakers. E foi esse ato que... me salvou, por assim dizer. 
        </p>
        <p>
          A cá estamos, proximos ao segundo livro. Como mencionei, esse livro é uma extensão minha, só não posso dizer que é uma biografia, afinal
          ainda não manipulo fogo... mas... quem sabe um dia, não?
        </p>
      </div>

      <!-- Fatos rápidos -->
      <div class="autor-facts">
        <div class="autor-fact">
          <span class="fact-number">1</span>
          <span class="fact-label">Livro Publicado</span>
        </div>
        <div class="autor-fact">
          <span class="fact-number">6+</span>
          <span class="fact-label">Anos Criando</span>
        </div>
      </div>
    </div>
  </div>
</section>
